export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";